/*
<summary>
   This enum defines the tool_master.tool_type values, driving the Tool Management module's
   General Tool / Main Unit / Applicator tabs.
   Developer: Aashish Singh, Created Date: 24-Aug-2026
</summary>
*/
enum ToolTypeEnum {
  GeneralTool = 1,
  MainUnit = 2,
  Applicator = 3,
}

export default ToolTypeEnum;
